import {
  Button,
  Layout,
  SurveyTransition as SurveyTransitionBase,
} from "@ptsd/uikit";
import { ArrowRight } from "@tamagui/lucide-icons";
import { Text, useMedia, View, XStack } from "tamagui";

import { api } from "~/utils/api";
import { Footer, Header, useLayoutScrollProps } from "~/component/layout";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const image = require("../../assets/onboarding/frame-1.png");

interface PerPersonDataSharingAgreementProps {
  content: {
    title: string;
    description: string;
    acceptButtonLabel: string;
    acceptingButtonLabel: string;
    errorMessage: string;
  };
}

export const PerPersonDataSharingAgreement = ({
  content,
}: PerPersonDataSharingAgreementProps) => {
  const { sm } = useMedia();
  const scrollProps = useLayoutScrollProps();
  const utils = api.useUtils();

  const {
    mutate: agreeToPerPersonDataSharing,
    isLoading,
    isError,
  } = api.patient.agreeToPerPersonDataSharing.useMutation({
    onSuccess: async () => {
      await utils.context.person.invalidate();
    },
    onError: (error) => {
      if (error.data?.code === "FORBIDDEN") {
        void utils.context.person.invalidate();
      }
    },
  });

  return (
    <Layout variant="monobackground" scrollProps={scrollProps}>
      <Header isTutorial />
      <View
        alignSelf="center"
        flexDirection="row"
        maxWidth={1248}
        paddingHorizontal={"$3"}
        flex={2}
        width={"100%"}
        $sm={{
          flexDirection: "column-reverse",
          alignSelf: "flex-start",
          paddingTop: "$4",
          gap: "$2.5",
        }}
      >
        <View
          flex={1}
          width={"50%"}
          justifyContent="center"
          alignSelf="center"
          paddingRight={"$5.1"}
          $sm={{
            paddingRight: 0,
            width: "100%",
          }}
        >
          <View
            maxWidth={558}
            gap={"$10"}
            $sm={{
              width: "100%",
              maxWidth: 1000,
              gap: "$3",
            }}
          >
            <View
              gap={"$4"}
              $sm={{
                gap: "$2",
              }}
            >
              <View>
                <SurveyTransitionBase.Title>
                  {content.title}
                </SurveyTransitionBase.Title>
              </View>

              <SurveyTransitionBase.Description>
                {content.description}
              </SurveyTransitionBase.Description>
            </View>

            <View
              gap={"$2"}
              $sm={{
                alignSelf: "center",
              }}
            >
              <XStack gap={"$1"}>
                <Button
                  data-id="per-person-data-sharing-agreement-button"
                  variant="primary"
                  size="lg"
                  rounded="lg"
                  iconAfter={<ArrowRight color="white" size={"$2.5"} />}
                  flex={1}
                  maxWidth={308}
                  disabled={isLoading}
                  onPress={() => agreeToPerPersonDataSharing()}
                  {...(sm && {
                    size: "md",
                  })}
                >
                  {isLoading
                    ? content.acceptingButtonLabel
                    : content.acceptButtonLabel}
                </Button>
              </XStack>
              {isError && (
                <Text color={"$error-500"} fontFamily={"$body"}>
                  {content.errorMessage}
                </Text>
              )}
            </View>
          </View>
        </View>

        <View
          justifyContent="center"
          alignSelf="center"
          paddingLeft={"$5.1"}
          width={"50%"}
          flex={1}
          $sm={{
            paddingLeft: 0,
            maxWidth: 1000,
            width: "100%",
            alignItems: "center",
          }}
        >
          <SurveyTransitionBase.Image src={image} />
        </View>
      </View>

      {sm && (
        <View paddingTop={"$5"}>
          <Footer />
        </View>
      )}
    </Layout>
  );
};
